import React, { FC } from "react";
import { TitleWrapper } from "./styled";

const Title: FC = ({ children }) => {
  return <TitleWrapper className="px-3">{children}</TitleWrapper>;
};

export default Title;
